import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { routes } from '../../config/constants';
import SignIn from '../signin';
import ProtectedRoute from './protected';

const BrowserRoutes = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/">
            <Route path={routes.signin} element={<SignIn />} />
            <Route path={routes.main} element={<ProtectedRoute />} />
            <Route path="*" element={<ProtectedRoute />} />
        </Route>
    )
);

export default BrowserRoutes;
